import { useTranslation } from 'react-i18next';

import { Star, StarFilled } from '../icons';
import { FavouriteCta as FavouriteCtaWrapper } from '../../assets/styles/components/dashboard.styled';

interface FavouriteCtaProps {
  isFavourite: boolean;
  onToggle: (value: boolean) => void;
  classname?: string;
}

const FavouriteCta: React.FC<FavouriteCtaProps> = ({ isFavourite, onToggle, classname }) => {
  const { t } = useTranslation();

  return (
    <FavouriteCtaWrapper
      type="button"
      className={`${isFavourite ? 'active' : ''} ${classname ?? ''}`.trim()}
      data-testid="favourite-filter-button"
      aria-label={t('common:favorites')}
      aria-pressed={isFavourite}
      onClick={() => onToggle(!isFavourite)}
    >
      {isFavourite ? <StarFilled /> : <Star />}
    </FavouriteCtaWrapper>
  );
};

export default FavouriteCta;
